import React, { useContext, useEffect, useState } from "react";
import AdminBookingCard from "../components/AdminBookingCard";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import ErrorAlert from "../components/ErrorAlert";
import NothingToShow from "../../components/NothingToShow";
import { ExpiringContext } from "../../context/ExpiringBookings";

export default function AllBookings() {
  // Using Context
  const expireCheckComplete = useContext(ExpiringContext);

  // State Handling
  const [error, setError] = useState("");
  const [fetchedData, setFetchedData] = useState([]);
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Bookings From Database ---------
  const readingData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/read-bookings"
      );
      const result = await response.json();

      if (!response.ok) {
        setError("Bookings can't be fetched");
      } else if (response.ok) {
        setTimeout(() => {
          setError("");
        }, 10000);
        setFetchedData(result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    readingData();
  }, [expireCheckComplete]);

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Fetching...</p>
      </div>
    );

  if (!loading)
  return (
    <>
      {/* Showing Alert based on http request response Start */}
      {error && <ErrorAlert errorMsg={error} />}
      {/* Showing Alert based on http request response End */}

      {/* All Bookings Heading Start */}
      <AdminPanelGeneralHeading text="All Bookings" classes="px-2" />
      {/* All Bookings Heading End */}

      {/* All Bookings Cards Start*/}
      <div className="col-12 d-flex flex-wrap justify-content-start align-items-center">
        {!fetchedData.length ? <NothingToShow /> : ""}

        {fetchedData?.map((singleBooking) => {
          return (
            <AdminBookingCard
              key={singleBooking._id}
              img={singleBooking.room_img}
              bookingIdForUpdate={singleBooking._id}
              bookingHolderName={singleBooking.booking_holder_name}
              bookingId={`bid${singleBooking._id.slice(
                0,
                5
              )}of${singleBooking.booking_holder_email.slice(0, 3)}`}
              fromDate={singleBooking.booking_from}
              toDate={singleBooking.booking_to}
              hotelName={singleBooking.booking_hotel}
              room={singleBooking.booking_room_number}
              rentPerDay={singleBooking.booking_room_price}
              totalAmount={singleBooking.booking_total}
              bookingStatus={singleBooking.booking_status}
            />
          );
        })}
      </div>
      {/* All Bookings Cards End */}
    </>
  );
}
